import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDashboardComponent implements OnInit {
    public state: string = 'loading';
    public error: string = '';
    public stats: any[] = [];
    public recent: any[] = [];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.state = 'loading';
        this.error = '';
        await this.service.render();
        const { code, data } = await wiz.call('overview');
        if (code === 200) {
            this.stats = data.stats || [];
            this.recent = data.recent || [];
            this.state = this.recent.length ? 'ready' : 'empty';
        } else {
            this.stats = [];
            this.recent = [];
            this.error = data?.message || data || '대시보드 데이터를 불러오지 못했습니다.';
            this.state = 'error';
        }
        await this.service.render();
    }
}

export default PageDashboardComponent;